import { render } from "./NImageViewerBboxDistancesLayer.vue?vue&type=template&id=a633f496&ts=true"
import script from "./NImageViewerBboxDistancesLayer.vue?vue&type=script&lang=ts"
export * from "./NImageViewerBboxDistancesLayer.vue?vue&type=script&lang=ts"

import "./NImageViewerBboxDistancesLayer.vue?vue&type=style&index=0&id=a633f496&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__